import React from 'react';
import { EnemyCombatPresetEditorPopup } from '../combat/EnemyCombatPresetEditorPopup';
import { GesturePatternEditorPopup } from '../combat/GesturePatternEditorPopup';
export const EditorPopupWindows = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EnemyCombatPresetEditorPopup, null), /*#__PURE__*/React.createElement(GesturePatternEditorPopup, null));
};